module.exports = __webpack_public_path__ + "img/introduce.949e109f.png";